export default __webpack_public_path__ + "static/media/litho-demo-fashion-shop.552cdd92.jpg";